import { render } from "./MyInput.vue?vue&type=template&id=35cbbaff&scoped=true"
import script from "./MyInput.vue?vue&type=script&lang=js"
export * from "./MyInput.vue?vue&type=script&lang=js"

import "./MyInput.vue?vue&type=style&index=0&id=35cbbaff&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cbbaff"]])

export default __exports__